import type { CommunityMemberSelectProps } from "@circle-react-uikit/CommunityMemberSelect";
import { CommunityMemberSelect as UIKitCommunityMemberSelect } from "@circle-react-uikit/CommunityMemberSelect";
import { CommunityMemberSelectCompass } from "@circle-react/components/shared/CommunityMemberSelectCompass";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";
// eslint-disable-next-line no-barrel-files/no-barrel-files -- This is a compatibility layer that re-exports types for SettingsApp
export type { CommunityMemberSelectProps };

export const CommunityMemberSelect = (props: CommunityMemberSelectProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled(
    "circle_v4_form_elements_enabled",
  );

  if (!isCircleV4) {
    return <UIKitCommunityMemberSelect {...props} />;
  }

  const { variant, addable, onChange, value, ...compassProps } = props;

  if (variant === "tags") {
    return (
      <CommunityMemberSelectCompass
        {...compassProps}
        addable={Boolean(addable)}
        multiple
        onChange={values => {
          onChange?.({ value: values });
        }}
        value={Array.isArray(value) ? value : []}
      />
    );
  }

  return (
    <CommunityMemberSelectCompass
      {...compassProps}
      addable={Boolean(addable)}
      onChange={v => {
        onChange?.({ value: v });
      }}
      value={typeof value === "number" ? value : null}
    />
  );
};

CommunityMemberSelect.displayName = "CommunityMemberSelect";
